var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$auth.hasAccessToCompanyProfile())?_c('CompanyDetail',_vm._b({attrs:{"id":_vm.$auth.companyId()}},'CompanyDetail',Object.assign({}, (_vm.$props || {}), (_vm.$route.params || {})),false)):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }